var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import Tab from '../../Tab';
import RelativeDatePicker from './RelativeDatePicker';
import AbsoluteDatePicker from './AbsoluteDatePicker';
var DateTimeRangePickerPanel = function (_a) {
    var range = _a.range, _b = _a.onChange, onChange = _b === void 0 ? function () { return null; } : _b;
    return (_jsx("div", __assign({ className: "w-[300px] p-2 rounded bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300" }, { children: _jsx(Tab, { tabs: ['Relative', 'Absolute'], panels: [
                _jsx(RelativeDatePicker, { range: range, onChange: function (from, to) { return onChange(from, to); } }),
                _jsx(AbsoluteDatePicker, { range: range, onChange: function (from, to) { return onChange(from, to); } }),
            ], defaultTabIndex: range.from.isRelative() ? 0 : 1 }) })));
};
export default DateTimeRangePickerPanel;
